/* eslint-disable */
import WebFont from 'webfontloader';
import { AssetBundle, AssetBundleState } from '../../platform/assets/AssetBundle';
import { Host } from '../../Host';
import './google/Inter/import.css';
import './google/Rubik/import.css';
import './google/Barlow/import.css';
import './google/Bitter/import.css';
import './google/Cabin/import.css';
import './google/Dosis/import.css';
import './google/Fira-Mono/import.css';
import './google/Fira-Sans/import.css';
import './google/Gentium-Book-Plus/import.css';
import './google/Hind/import.css';
import './google/Kanit/import.css';
import './google/Lato/import.css';
import './google/Lora/import.css';
import './google/Merriweather/import.css';
import './google/Montserrat/import.css';
import './google/Open-Sans/import.css';
import './google/Oxygen/import.css';
import './google/PT-Mono/import.css';
import './google/Quicksand/import.css';
import './google/Raleway/import.css';
import './google/Roboto-Condensed/import.css';
import './google/Roboto/import.css';
import './google/Ubuntu/import.css';
import './google/Architects-Daughter/import.css';
import './google/Caveat/import.css';
import './google/Coming-Soon/import.css';
import './google/Dekko/import.css';
import './google/Delius/import.css';
import './google/Handlee/import.css';
import './google/Itim/import.css';
import './google/Kalam/import.css';
import './google/Kavivanar/import.css';
import './google/Mali/import.css';
import './google/Merienda/import.css';
import './google/Neucha/import.css';
import './google/Patrick-Hand/import.css';
import './google/Short-Stack/import.css';
import './google/Swanky-and-Moo-Moo/import.css';
import './google/Tillana/import.css';
import './google/Walter-Turncoat/import.css'

export class GoogleFontBundle implements AssetBundle {

    public state: AssetBundleState = 'waiting';

    public async load(): Promise<void> {
        this.state = 'loading';

        return new Promise((rs, rj) => {
            WebFont.load({
                custom: {
                    families: [
                        'Inter',
                        'Rubik',
                        'Barlow',
                        'Bitter',
                        'Cabin',
                        'Dosis',
                        'Fira Mono',
                        'Fira Sans',
                        'Gentium Book Plus',
                        'Hind',
                        'Kanit',
                        'Lato',
                        'Lora',
                        'Merriweather',
                        'Montserrat',
                        'Open Sans',
                        'Oxygen',
                        'PT Mono',
                        'Quicksand',
                        'Raleway',
                        'Roboto Condensed',
                        'Roboto',
                        'Ubuntu',
                        'Architects Daughter',
                        'Caveat',
                        'Coming Soon',
                        'Dekko',
                        'Delius',
                        'Handlee',
                        'Itim',
                        'Kalam',
                        'Kavivanar',
                        'Mali',
                        'Merienda',
                        'Neucha',
                        'Patrick Hand',
                        'Short Stack',
                        'Swanky and Moo Moo',
                        'Tillana',
                        'Walter Turncoat'
                    ],
                    urls: [
                        `${Host.cdnUrl}/app/index.css`
                    ]
                },
                active: () => rs(),
                inactive: () => {
                    console.error(new Error('GoogleFontBundle: Some fonts failed to load.'));
                    rs();
                },
            });
        });
    }
}


